module.exports = __webpack_public_path__ + "images/07261b11f0e76225441d118bec100a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/ksenia.jpg
// module id = 145
// module chunks = 24